import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = 'G-HDHEJ4TJ4X';

const GoogleAnalytics = () => {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  // Track scroll depth (25%, 50%, 75%, 90%, 100%) per page
  useEffect(() => {
    const thresholds = [25, 50, 75, 90, 100];
    const reached = new Set();

    const onScroll = () => {
      const doc = document.documentElement;
      const scrollTop = window.scrollY || doc.scrollTop;
      const viewportH = window.innerHeight || doc.clientHeight;
      const totalH = doc.scrollHeight - viewportH;
      if (totalH <= 0) return;
      const percent = Math.min(100, Math.round((scrollTop / totalH) * 100));

      thresholds.forEach((t) => {
        if (percent >= t && !reached.has(t)) {
          reached.add(t);
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'scroll_depth', {
              percent_scrolled: t,
              page_path: location.pathname,
            });
          }
        }
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    // Trigger once in case page is short
    onScroll();

    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname]);

  return null;
};

export default GoogleAnalytics;
